import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "info"
}
const _hoisted_2 = {
  key: 0,
  class: "info-content"
}
const _hoisted_3 = {
  key: 1,
  class: "info-content"
}
const _hoisted_4 = {
  key: 2,
  class: "info-content"
}
const _hoisted_5 = {
  key: 3,
  class: "info-content"
}
const _hoisted_6 = {
  key: 1,
  class: "info"
}
const _hoisted_7 = {
  key: 0,
  class: "info-content"
}
const _hoisted_8 = {
  key: 1,
  class: "info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.isEmailBelongsToCustomer !== false)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (!$setup.showCustomOnlyTerms)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              ($setup.props.isRefundable && !$setup.props.isZeroDeposit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, "To purchase this lot, please complete the Contract Information Form below and pay a " + _toDisplayString($setup.formatStripePrice($setup.props.deposit)) + " initial holding deposit. The deposit will be refunded in the event that you are unsuccessful in securing this lot, or you decide not to proceed with the purchase.", 1))
                : (!$setup.props.isRefundable && !$setup.props.isZeroDeposit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, "To purchase this lot, please complete the Contract Information Form below and pay a " + _toDisplayString($setup.formatStripePrice($setup.props.deposit)) + " initial holding deposit. The deposit will be automatically refunded in the event that you are unsuccessful in securing this lot. Once you have been allocated a lot the deposit is not refundable.", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, "To purchase this lot, please complete the Contract Information Form below.")),
              ($props.customTerms.text)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($props.customTerms.text), 1))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              ($props.customTerms.text)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($props.customTerms.text), 1))
                : _createCommentVNode("", true)
            ]))
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "info-content" }, "The email address that you entered is already associated with an existing user with Admin or Sales User permissions. Please use a different email address to proceed.", -1)
      ]))]))
}